import { icons } from '@/components/common/Icon';

export const jobPositions = [
  {
    id: 'senior-software-engineer',
    title: 'Senior Software Engineer',
    department: 'Engineering',
    location: 'Bengaluru',
    type: 'Full-time',
    description: 'engineers who can optimize for quick iteration, fast deployment, and a great developer experience. Build and maintain apps using Node.js, Golang, Java, and other cool tech.',
    salary: '₹28L – ₹35L',
    equity: '0.0% – 0.5%',
    postedDate: '4 days ago',
    applyUrl: 'https://wellfound.com/jobs/2670911-senior-software-engineer'
  },
  {
    id: 'senior-product-manager',
    title: 'Senior Product Manager',
    department: 'Product',
    location: 'India · Bengaluru',
    type: 'Full-time',
    description: 'engineers who can optimize for quick iteration, fast deployment, and a great developer experience. Craft a clear product vision and roadmap aligned with company goals.',
    salary: '₹27L – ₹35L',
    equity: 'No equity',
    postedDate: '4 days ago',
    applyUrl: 'https://wellfound.com/jobs/2735864-senior-product-manager'
  },
  {
    id: 'salesforce-developer',
    title: 'Salesforce Developer - (Immediate Joiners Only)',
    department: 'Engineering',
    location: 'Bengaluru',
    type: 'Full-time',
    description: 'Note - Since we receive many application and can\'t read all the resumes please explain in 1-2 lines why you are the perfect candidate, highlighting any specific skills. Mention how soon you will be able to join.',
    salary: '₹8L – ₹15L',
    equity: 'No equity',
    postedDate: '7 days ago',
    applyUrl: 'https://wellfound.com/jobs/3269710-salesforce-developer-immediate-joiners-only'
  }
];

export const companyValues = [
  {
    title: 'Innovation',
    description: 'We push boundaries and embrace new technologies to create extraordinary solutions.',
    iconPath: 'https://cobalt-app-logos.s3.ap-south-1.amazonaws.com/website_images/Careers/innovation-icon.svg',
  },
  {
    title: 'Customer Focus',
    description: 'We build for our customers first, creating products that solve real-world problems.',
    iconPath: 'https://cobalt-app-logos.s3.ap-south-1.amazonaws.com/website_images/Careers/customer-focus-icon.svg',
  },
  {
    title: 'Collaboration',
    description: 'We work together across teams, sharing knowledge and supporting each other.',
    iconPath: 'https://cobalt-app-logos.s3.ap-south-1.amazonaws.com/website_images/Careers/collaboration-icon.svg',
  },
  {
    title: 'Transparency',
    description: 'We communicate openly and honestly, both internally and with our customers.',
    iconPath: 'https://cobalt-app-logos.s3.ap-south-1.amazonaws.com/website_images/Careers/transparency-icon.svg',
  },
  {
    title: 'Growth Mindset',
    description: 'We embrace challenges and persist in the face of setbacks, viewing them as opportunities to learn.',
    iconPath: 'https://cobalt-app-logos.s3.ap-south-1.amazonaws.com/website_images/Careers/growth-mindset-icon.svg',
  }
];

export const benefitsData = {
   title: "Why Cobalt?",
   subtitle: "We're on a mission to reimagine SaaS integrations—and we can't do it without you",
   benefits: [
  {
    title: 'AI workflows powering Cobalt 3.0',
    description: 'Work on cutting-edge AI workflows shaping the next era of software development',
    iconPath: 'https://cobalt-app-logos.s3.ap-south-1.amazonaws.com/website_images/Career+Page/ai+workflow.svg',
  },
  {
    title: 'Accelerate Your Growth with Mentorship & Learning',
    description: 'Get personalized learning paths and hands-on mentorship from top industry experts.',
    iconPath: 'https://cobalt-app-logos.s3.ap-south-1.amazonaws.com/website_images/Career+Page/mentorship.svg',
  },
  {
    title: 'Thrive in a People-First, Inclusive Culture',
    description: 'Experience a workplace where your voice is heard and your well-being truly matters.',
    iconPath: 'https://cobalt-app-logos.s3.ap-south-1.amazonaws.com/website_images/Career+Page/competitive+salary.svg',
  },
  {
    title: 'Scale with Visionary Tech Leadership',
    description: 'Collaborate with globally respected leaders who’ve built products used by millions.',
    iconPath: 'https://cobalt-app-logos.s3.ap-south-1.amazonaws.com/website_images/Career+Page/people+first.svg',
  },
  {
    title: 'Make a Global Impact from Day One',
    description: 'Join a team solving deep tech problems that touch users and developers worldwide.',
    iconPath: 'https://cobalt-app-logos.s3.ap-south-1.amazonaws.com/website_images/Career+Page/tech+leader.svg',
  },
  {
    title: 'Own Your Journey with Real Autonomy',
    description: 'Take charge of meaningful work with the freedom to innovate and lead at every level.',
    iconPath: 'https://cobalt-app-logos.s3.ap-south-1.amazonaws.com/website_images/Career+Page/flexibility.svg',
  }
]
}

export const teamTestimonials = [
  {
    quote: 'At Cobalt, I\'ve had the opportunity to work on challenging problems while growing both technically and professionally. The team culture is supportive, and we\'re building something that truly helps our customers.',
    author: {
      name: 'Priya Sharma',
      title: 'Senior Frontend Engineer',
      image: 'https://cobalt-app-logos.s3.ap-south-1.amazonaws.com/website_images/Careers/priya-sharma.jpg'
    }
  },
  {
    quote: 'What I love about working at Cobalt is that everyone\'s voice matters. We move fast but thoughtfully, with a strong focus on building features that make our customers successful.',
    author: {
      name: 'Alex Rodriguez',
      title: 'Product Manager',
      image: 'https://cobalt-app-logos.s3.ap-south-1.amazonaws.com/website_images/Careers/alex-rodriguez.jpg'
    }
  },
  {
    quote: 'The problems we solve at Cobalt are complex and interesting. We\'re constantly pushing the boundaries of what\'s possible with integrations, and it\'s exciting to be part of that journey.',
    author: {
      name: 'Raj Patel',
      title: 'Backend Engineer',
      image: 'https://cobalt-app-logos.s3.ap-south-1.amazonaws.com/website_images/Careers/raj-patel.jpg'
    }
  }
];

export const careersData = {
  hero: {
    tag: {
      text: 'CAREERS',
      href: '/careers',
    },
    title: "Build the Future of AI-Driven Integrations",
    description: "At Cobalt, we're redefining SaaS connectivity with AI at the core and people at the heart. If solving complex integration challenges excites you, you're in the right place.",
    cta: {
      primary: {
        text: 'View Open Positions',
        href: 'https://wellfound.com/company/cobalt-8',
      },
    },
    backgroundImage: 'https://cobalt-app-logos.s3.ap-south-1.amazonaws.com/website_images/Career+Page/Career+page+hero+image.svg'
  },

  lifeAtCobalt: {
    title: "Behind the Code: Life at Cobalt",
    description: "Peek into the world of Cobalt—where every day sparks creativity, collaboration, and breakthroughs.",
    images: [
      "./about-us/team-1.png",
      "./about-us/team-2.png",
      "./about-us/team-3.png",
      "./about-us/team-7.png",
      "./about-us/team-9.png",
      "./about-us/team-10.png",
    ]
  },

  bentoProcess: {
    title: "From Hello to Hired",
    description: "Our straightforward hiring process",
    features: [
      {
        title: "Apply",
        description: "Tell us about yourself.",
        icon: "fileText" as keyof typeof icons
      },
      {
        title: "Connect",
        description: "Let's have a conversation.",
        icon: "message" as keyof typeof icons
      },
      {
        title: "Show Your Skills",
        description: "Tackle a challenge that reflects your future role.",
        icon: "code" as keyof typeof icons
      },
      {
        title: "Join Us",
        description: "Get ready to make magic happen.",
        icon: "star" as keyof typeof icons
      }
    ]
  },

  testimonials: {
    tag: "TEAM VOICES",
    title: "Hear from our team members"
  },

  mission: {
    tag: 'OUR MISSION',
    title: 'Enabling seamless connections between software applications',
    description: 'At Cobalt, we\'re reimagining how software connects with the world. Our embedded iPaaS platform helps SaaS companies deliver native integrations faster, scale efficiently, and create delightful experiences for their customers.',
    stats: [
      {
        number: '2020',
        label: 'Founded'
      },
      {
        number: '50+',
        label: 'Team Members'
      },
      {
        number: '15+',
        label: 'Countries'
      },
      {
        number: '100%',
        label: 'Remote'
      }
    ],
    image: 'https://cobalt-app-logos.s3.ap-south-1.amazonaws.com/website_images/Careers/team-working.jpg'
  },
  culture: {
    tag: 'OUR CULTURE',
    title: 'Building a workplace where everyone can thrive',
    description: 'We believe that great products are built by great teams. That\'s why we\'ve created a culture that values diversity, collaboration, and continuous learning.',
    video: {
      thumbnail: 'https://cobalt-app-logos.s3.ap-south-1.amazonaws.com/website_images/Careers/culture-video-thumbnail.jpg',
      url: 'https://www.youtube.com/embed/example-video-id'
    }
  },
  openPositions: {
    tag: 'JOIN OUR TEAM',
    title: 'Find your next opportunity at Cobalt',
    description: 'We\'re growing quickly and looking for talented individuals to join our team. Check out our open positions below.'
  },
  team: {
    tag: 'OUR TEAM',
    title: 'Meet some of our talented team members',
    description: 'Hear directly from the people who make Cobalt great.'
  },
  apply: {
    tag: 'APPLICATION PROCESS',
    title: 'Our hiring process',
    steps: [
      {
        number: '01',
        title: 'Application Review',
        description: 'We review your resume and cover letter to understand your experience and skills.'
      },
      {
        number: '02',
        title: 'Initial Interview',
        description: 'A conversation with our recruiting team to learn more about you and your background.'
      },
      {
        number: '03',
        title: 'Technical Assessment',
        description: 'A practical exercise relevant to the role you\'re applying for.'
      },
      {
        number: '04',
        title: 'Team Interviews',
        description: 'Meet with potential teammates and leaders to discuss your experience and our culture.'
      },
      {
        number: '05',
        title: 'Final Decision',
        description: 'We make a decision and extend an offer to successful candidates.'
      }
    ]
  },
  diversity: {
    tag: 'DIVERSITY & INCLUSION',
    title: 'Building a team that represents the world we serve',
    description: 'We\'re committed to creating an inclusive environment where everyone feels welcome, valued, and heard. We believe that diversity leads to better products and a stronger company.',
    image: 'https://cobalt-app-logos.s3.ap-south-1.amazonaws.com/website_images/Careers/diversity-team.jpg'
  },
  cta: {
    title: 'Ready to join us?',
    description: 'Check out our open positions and apply today',
    cta: {
      text: 'View Open Positions',
      href: 'https://wellfound.com/company/cobalt-8'
    }
  },
  stayConnected: {
    title: 'Stay Connected',
    description: "Didn't see your dream role? We'd still love to hear from you.",
    email: {
      text: 'careers@gocobalt.io',
      address: 'careers@gocobalt.io'
    },
    linkedin: {
      text: 'follow us on LinkedIn',
      href: 'https://www.linkedin.com/company/gocobalt'
    }
  }
};